export default {
      id: "arcs_alu-usage",
      viewBox: "0 0 200 230",
      url: "../dist/images/" + "sprite.svg#arcs_alu-usage",
      toString: function () {
        return this.url;
      }
    }